import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { PageHeader } from '../components/common/PageHeader';
export function PublishCase() {
  const nav = useNavigate();
  const [form, setForm] = useState({
    title: '',
    bgSchool: '',
    bgGpa: '',
    bgLang: '',
    offers: '',
    major: '',
    story: ''
  });
  const submit = () => {
    if (!form.title || !form.offers || !form.story) {
      toast.error('请填写必填项');
      return;
    }
    toast.success('案例发布成功，审核中');
    nav(-1);
  };
  return <div className="bg-slate-50 min-h-screen pb-24" data-id="element-621">
      <PageHeader title="发布录取案例" data-id="element-622" />

      <div className="p-4 space-y-4" data-id="element-623">
        <div className="bg-white rounded-2xl p-4 space-y-4" data-id="element-624">
          <div data-id="element-625">
            <label className="block text-sm font-bold text-slate-800 mb-1.5" data-id="element-626">
              标题 <span className="text-rose-500" data-id="element-627">*</span>
            </label>
            <input value={form.title} onChange={e => setForm({
            ...form,
            title: e.target.value
          })} placeholder="例如：双非逆袭 G5，我的申请经验" className="w-full bg-slate-50 border border-slate-100 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-blue-500" data-id="element-628" />
          </div>

          <div className="grid grid-cols-2 gap-3" data-id="element-629">
            <div data-id="element-630">
              <label className="block text-sm font-bold text-slate-800 mb-1.5" data-id="element-631">
                本科院校
              </label>
              <input value={form.bgSchool} onChange={e => setForm({
              ...form,
              bgSchool: e.target.value
            })} placeholder="例如：双非 / 211" className="w-full bg-slate-50 border border-slate-100 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-blue-500" data-id="element-632" />
            </div>
            <div data-id="element-633">
              <label className="block text-sm font-bold text-slate-800 mb-1.5" data-id="element-634">
                GPA
              </label>
              <input value={form.bgGpa} onChange={e => setForm({
              ...form,
              bgGpa: e.target.value
            })} placeholder="例如：3.8/4.0" className="w-full bg-slate-50 border border-slate-100 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-blue-500" data-id="element-635" />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3" data-id="element-636">
            <div data-id="element-637">
              <label className="block text-sm font-bold text-slate-800 mb-1.5" data-id="element-638">
                语言成绩
              </label>
              <input value={form.bgLang} onChange={e => setForm({
              ...form,
              bgLang: e.target.value
            })} placeholder="例如：雅思 7.0" className="w-full bg-slate-50 border border-slate-100 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-blue-500" data-id="element-639" />
            </div>
            <div data-id="element-640">
              <label className="block text-sm font-bold text-slate-800 mb-1.5" data-id="element-641">
                录取专业
              </label>
              <input value={form.major} onChange={e => setForm({
              ...form,
              major: e.target.value
            })} placeholder="例如：计算机科学" className="w-full bg-slate-50 border border-slate-100 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-blue-500" data-id="element-642" />
            </div>
          </div>

          <div data-id="element-643">
            <label className="block text-sm font-bold text-slate-800 mb-1.5" data-id="element-644">
              录取院校 (逗号分隔) <span className="text-rose-500" data-id="element-645">*</span>
            </label>
            <input value={form.offers} onChange={e => setForm({
            ...form,
            offers: e.target.value
          })} placeholder="例如：帝国理工学院, 伦敦大学学院" className="w-full bg-slate-50 border border-slate-100 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-blue-500" data-id="element-646" />
          </div>
        </div>

        <div className="bg-white rounded-2xl p-4" data-id="element-647">
          <label className="block text-sm font-bold text-slate-800 mb-1.5" data-id="element-648">
            申请故事 <span className="text-rose-500" data-id="element-649">*</span>
          </label>
          <textarea value={form.story} onChange={e => setForm({
          ...form,
          story: e.target.value
        })} placeholder="分享你的备考、选校、文书、面试等经验..." className="w-full bg-slate-50 border border-slate-100 rounded-xl px-3 py-3 text-sm outline-none focus:border-blue-500 h-40 resize-none" data-id="element-650" />
        </div>

        <button onClick={submit} className="w-full h-12 rounded-full bg-blue-600 text-white font-bold shadow-lg" data-id="element-651">
          发布案例
        </button>
      </div>
    </div>;
}